var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7692 0.115356H1.23079C0.904369 0.115356 0.591319 0.245026 0.360505 0.47584C0.129691 0.706654 2.14302e-05 1.0197 2.14302e-05 1.34612V13.6538C-0.00136922 13.8884 0.0649492 14.1184 0.191021 14.3162C0.317094 14.5141 0.497566 14.6714 0.71079 14.7692C0.873726 14.8448 1.05115 14.8842 1.23079 14.8846C1.51971 14.8839 1.79906 14.7809 2.01925 14.5938L2.02617 14.5884L4.53848 12.423H14.7692C15.0957 12.423 15.4087 12.2934 15.6395 12.0625C15.8703 11.8317 16 11.5187 16 11.1923V1.34612C16 1.0197 15.8703 0.706654 15.6395 0.47584C15.4087 0.245026 15.0957 0.115356 14.7692 0.115356ZM14.7692 11.1923H4.30771C4.15995 11.1923 4.01715 11.2456 3.9054 11.3423L1.23079 13.6538V1.34612H14.7692V11.1923Z",
    fill: "#6921C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.11536H11",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.61536H11",
    stroke: "#FF6019",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIconNew);
export default __webpack_public_path__ + "static/media/smsIconNew.0df75bc6.svg";
export { ForwardRef as ReactComponent };